import { CustomerLiteModel } from 'api-hooks/customer';
import { colors } from 'baseui/tokens';
import { NavigationRoutes } from 'common/constants';
import { capitalize } from 'common/utils/string';
import Text from 'components/elements/text';
import useNavigation from 'hooks/use-navigation';
import { CardSection } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { StyleObject } from 'styletron-standard';

import { ActionButton, HalfSection } from './style';

interface Props {
  customer: CustomerLiteModel;
  onDismiss: () => void;
}

export default function CustomerCard(props: Props) {
  const { t } = useTranslation();
  const { customer } = props;
  const { navigate } = useNavigation();

  const redirect = () => {
    navigate(NavigationRoutes.CustomersView, {
      id: props.customer.id,
    });
    props.onDismiss();
  };

  const onKeyDown: React.KeyboardEventHandler<HTMLDivElement> = (e) => {
    if (e.key === 'Enter') {
      redirect();
    }
    e.stopPropagation();
  };

  return (
    <CardSection style={{ flexDirection: 'row' }}>
      <HalfSection>
        <Text variant="LabelMedium" $style={$style.wrappingText}>
          {`${capitalize(customer.title) || ''} ${customer.name}`}
        </Text>
        <Text
          variant="LabelSmall"
          $style={{ ...$style.wrappingText, ...$style.informationText }}
        >
          {`${customer.alias || ''} - ${customer.description || ''}`}
        </Text>
        <Text
          variant="LabelSmall"
          $style={{ ...$style.wrappingText, ...$style.informationText }}
        >
          {customer.email}
        </Text>
        <Text
          variant="LabelSmall"
          $style={{
            ...$style.wrappingText,
            ...$style.informationText,
            marginBottom: 0,
          }}
        >
          {customer.phone}
        </Text>
      </HalfSection>
      <HalfSection style={{ alignItems: 'end' }}>
        <ActionButton tabIndex={0} onClick={redirect} onKeyDown={onKeyDown}>
          {t('customer:view_customer')}
        </ActionButton>
      </HalfSection>
    </CardSection>
  );
}

const $style: { [key: string]: StyleObject | any } = {
  wrappingText: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    marginBottom: '8px',
  },
  informationText: {
    color: colors.gray500,
  },
};
